var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCrown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.108415 2.915L1.19103 9.95203H16.8085L17.8911 2.915C17.9711 2.39502 17.3795 2.04037 16.9586 2.35604L13.5857 4.8857C13.2155 5.16328 12.6881 5.07299 12.4315 4.68797L9.62349 0.475924C9.32675 0.0308117 8.67276 0.0308117 8.37601 0.475924L5.568 4.68797C5.31136 5.07299 4.78397 5.16334 4.41378 4.8857L1.04088 2.35604C0.62003 2.04037 0.0283857 2.39502 0.108415 2.915ZM2.0032 13.8577H15.9922C16.4419 13.8577 16.8064 13.4932 16.8065 13.0435V11.2549H1.18896V13.0435C1.18896 13.4932 1.55351 13.8577 2.0032 13.8577Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCrown);
export default __webpack_public_path__ + "static/media/icon_crown.091c5db2f30503039a83670969336726.svg";
export { ForwardRef as ReactComponent };